export const humanReadableUuid = (
  uuid: UUID = '',
  lengthInChars = 8
): string => {
  if (uuid === null) {
    return '';
  }
  return uuid.split('-').join('').substring(0, lengthInChars);
};
